import { Controller } from '@hotwired/stimulus'
import { DirectUpload } from "@rails/activestorage"

export default class extends Controller {
  static values = {
    fileInputId: String,
    hoverClass: String,
  }
  static targets = ["instructions", "inprogress"]

  connect() {
    this.filesToUploadCount = 0
    this.filesUploadedCount = 0

    this.hoverClassValue = this.hoverClassValue || "opacity-0"
  }

  show(e) {
    e.preventDefault()
    this.element.classList.remove(this.hoverClassValue)
  }

  hide(e) {
    if (e) {
      e.preventDefault()
    }
    this.element.classList.add(this.hoverClassValue)
  }

  drop(e) {
    e.preventDefault()

    this.showInProgress()

    const files = e.dataTransfer.files

    this.filesUploadedCount = 0
    this.filesToUploadCount = files.length
    Array.from(files).forEach(file => this.uploadFile(file))
  }

  uploadFile(file) {
    const input = document.querySelector(`#${this.fileInputIdValue}`)
    const url = input.dataset.directUploadUrl
    const upload = new DirectUpload(file, url)

    upload.create((error, blob) => {
      if (error) {
        // handle the error
      } else {
        // add an appropriately named hidden input to the form w/ a value of blob.signed_id so that the blog ids will be transmitted in the normal upload flow
        const hiddenField = document.createElement('input')
        hiddenField.setAttribute("type", "hidden")
        hiddenField.setAttribute("value", blob.signed_id)
        hiddenField.name = input.name
        input.form.appendChild(hiddenField)

        this.filesUploadedCount += 1
        if (this.filesToUploadCount == this.filesUploadedCount) {
          this.hide()
          this.hideInProgress()
          input.form.requestSubmit()
        }
      }
    })
  }

  showInProgress() {
    this.instructionsTarget.classList.add("hidden")
    this.inprogressTarget.classList.remove("hidden")
  }

  hideInProgress() {
    this.instructionsTarget.classList.remove("hidden")
    this.inprogressTarget.classList.add("hidden")
  }
}